import * as React from "react";
import { useHideBanner } from "../hooks";

export const PageUndefined: React.FunctionComponent = (props) => {
  useHideBanner();

  return null;
};
